var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUpdatesUnknown = function SvgIconUpdatesUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#98A2B3",
    fillRule: "evenodd",
    d: "M2.895 7a1 1 0 0 1 1-1h7.21a1 1 0 1 1 0 2h-7.21a1 1 0 0 1-1-1Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconUpdatesUnknown;